import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {RouterModule} from '@angular/router';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NxModule} from '@nrwl/angular';
import {EffectsModule} from '@ngrx/effects';
import {StoreModule} from '@ngrx/store';
import {StoreRouterConnectingModule} from '@ngrx/router-store';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {NgrxHelperModule} from '@kion/ngrx-helper';
import {CmsModule} from '@kion/cms';
import {ApiEndpointModule} from '@kion/api-endpoint';
import {DynamicModule} from 'ng-dynamic-component';
import {MarkdownModule} from 'ngx-markdown';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {environment} from '../environments/environment';
import {AppRoutingModule} from './app.routing.module';
import {CoreModule} from '@kion/core';
import {DataAccessAuthsModule} from '@kion/data-access/data-access-auths';
import {OverlayModule} from '@angular/cdk/overlay';
import {FsUiModule} from '@kion/fs-ui';
import {ServiceWorkerModule} from '@angular/service-worker';
import {UiModule} from '@kion/ui';
import {APP_BASE_HREF} from '@angular/common';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    NxModule.forRoot(),
    EffectsModule.forRoot([]),
    StoreModule.forRoot({}, {
      runtimeChecks: {
        strictStateSerializability: false,
        strictActionSerializability: false,
        strictStateImmutability: true,
        strictActionImmutability: true
      }
    }),
    StoreRouterConnectingModule.forRoot({
      stateKey: 'router'
    }),
    StoreDevtoolsModule.instrument({
      name: 'DevStore',
      maxAge: 25,
      logOnly: environment.production
    }),
    AppRoutingModule,
    RouterModule,
    NgrxHelperModule,
    CmsModule.forRoot(
      {
        baseSite: environment.baseSite,
        project: environment.project as 'FS',
        isoCode: '',
        basePath: environment.basePath,
        routes: environment.routes
      },
      {
        baseUrl: environment.idp.baseUrl
      }
    ),
    ApiEndpointModule.forRoot(
      {
        rootUrl: environment.apiUrl,
        clientId: environment.clientId,
        clientSecret: environment.clientSecret,
        baseSite: environment.baseSite,
      }
    ),
    DynamicModule,
    MarkdownModule.forRoot(),
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      useDefaultLang: false
    }),
    CoreModule,
    DataAccessAuthsModule,
    OverlayModule,
    FsUiModule,
    ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    UiModule.forRoot(
      {
        basePath: environment.basePath
      }
    )
  ],
  providers: [{provide: APP_BASE_HREF, useValue: environment.basePath}],
  bootstrap: [AppComponent],
})
export class AppModule {
}

// required for AOT compilation
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, environment.production ? environment.basePath + "assets/i18n/" : '/assets/i18n/');
}
